import { RefObject, useState } from 'react';
import { useReactToPrint } from 'react-to-print';
import DataUrlHelper from '../../../../../../../../helpers/data-url.helper';
import { TranslationService } from '../../../../../../../../services/translation.service';
import { AnalyticsService } from '../../../../../../../../services/analytics-service';
import printIcon from '../../../../../../../../../assets/icons/print-regular.svg';
import calendarIcon from '../../../../../../../../../assets/icons/calendar-plus.svg';
import type { IJourney } from '../../../../../../../../models/journey.model';
import CalendarDownloads from '../CalendarDownloads';
import DeviceHelper, { DeviceType } from '../../../../../../../../helpers/device.helper';
import './style.scss';

function Toolbar({ journey, printContentRef }: { journey: IJourney; printContentRef: RefObject<HTMLDivElement | null> }) {
  // === STATE ===
  const [showCalendarArea, setShowCalendarArea] = useState(false);

  // === VARIABLES ===
  const browser = DeviceHelper.getBrowser();
  const isChromeForiOS = browser?.name === 'crios' && browser?.deviceType === DeviceType.iOS;
  const isSafari12orLower = browser?.deviceType === DeviceType.iOS && (browser?.version ? browser?.version < 13 : false);
  const canDownloadCalendar = !(isChromeForiOS || isSafari12orLower);

  const handlePrintButtonClick = useReactToPrint({ contentRef: printContentRef });

  return (
    <div className="d-print-none">
      <div className="d-flex travel-planner-details-toolbar">
        <button
          className="btn--as-link btn--outline-internal"
          type="button"
          onClick={() => {
            handlePrintButtonClick();
            AnalyticsService.addEvent(AnalyticsService.TravelPlannerCategory, 'Skriv ut', '');
          }}
        >
          <img src={DataUrlHelper.encode(printIcon)} alt="" />
          <span className="ms-1">{TranslationService.get('travelplanner.printversion')}</span>
        </button>
        {canDownloadCalendar && !journey.destinationLink && (
          <button
            className="btn--as-link btn--outline-internal"
            aria-expanded={showCalendarArea ? 'true' : 'false'}
            type="button"
            onClick={() => {
              setShowCalendarArea(!showCalendarArea);
              AnalyticsService.addEvent(AnalyticsService.TravelPlannerCategory, 'Lägg till i kalender', '');
            }}
          >
            <img src={DataUrlHelper.encode(calendarIcon)} alt="" />
            <span className="ms-1">{TranslationService.get('travelplanner.addcalendar')}</span>
          </button>
        )}
      </div>
      {showCalendarArea && <CalendarDownloads journey={journey} />}
    </div>
  );
}

export default Toolbar;
